/**
 * Calculate tax amount in cents
 * @param {number} subtotalInCents - The cart subtotal in cents
 * @param {object} taxRate - Tax rate object with food property (e.g., { food: 675 })
 * @returns {number} Tax amount in cents (rounded)
 */
export const calculateTax = (subtotalInCents, taxRate) => {
  // 1. Normalize Tax Rate
  // Divide by 10,000 to convert integer (675) -> percent (6.75) -> decimal (0.0675).
  const taxRateDecimal = taxRate.food / 10000;

  // 2. Calculate Raw Tax (in Cents)
  // Example: Subtotal 1000 ($10.00) * 0.0675 = 67.5 cents
  const rawTaxAmount = subtotalInCents * taxRateDecimal;

  // 3. Apply Rounding Rule
  // Since rawTaxAmount is already in cents (e.g., 67.5),
  // Math.round rounds to the nearest whole cent.
  // This satisfies the "round up if > 4" rule automatically on the 3rd decimal of the dollar amount.
  // (67.5 rounds up to 68).
  return Math.round(rawTaxAmount);
};

/**
 * Calculate total amount including tax in dollars
 * @param {number} subtotalInCents - The cart subtotal in cents
 * @param {object} taxRate - Tax rate object with food property (e.g., { food: 675 })
 * @returns {number} totalInCents - Total amount including tax in cents
 */
export const calculateTotal = (subtotalInCents, taxRate) => {
  // 1. Get tax in CENTS (Integer)
  const taxInCents = calculateTax(subtotalInCents, taxRate);

  // 2. Add Subtotal (Cents) + Tax (Cents)
  // Example: 1000 + 68 = 1068
  const totalInCents = subtotalInCents + taxInCents;

  return totalInCents;
};
